<template>
<div>
  <vs-alert color="success" v-if="added">
    <div>{{ $t('message.salaryProject.requestSuccessAdded') }}</div>
  </vs-alert>
  <vs-alert color="danger" v-if="error">
    <div>{{ $t('message.salaryProject.someError') }}</div>
  </vs-alert>
  <RequestForm v-if="requestForm"
                @close-form="requestForm = false"
                @confirm-form="confirmRequestForm"/>
  <CreateForm v-else-if="createForm" :data="employee"
              @close-form="createForm = false"
              @confirm-form="confirmCreateForm"
              @create-request="requestForm = true" />
  <EmployeesTable v-else :employees="getEmployees" @set-selected="setSelected"
                  @get-status="fetchEmployees"
                  @create-form="openCreateForm" @edit-data="editEmployee"
  />
</div>
</template>

<script>
import EmployeesTable from '@/layouts/components/salaryProject/employees/employeesTable'
import CreateForm from '@/layouts/components/salaryProject/employees/createForm'
import RequestForm from '@/layouts/components/salaryProject/employees/requestForm'
import { mapActions, mapGetters } from 'vuex'
import {isBoolean} from 'lodash'

export default {
  name: 'Employees',
  data: () => ({
    createForm: false,
    requestForm: false,
    employee: {id: null},
    added: false,
    error: false
  }),
  components: {CreateForm, EmployeesTable, RequestForm},
  methods: {
    ...mapActions('salary', ['fetchEmployees', 'addEmployees', 'updateEmployees', 'fetchPaymentActs', 'addOnboardingRequest']),
    openCreateForm () {
      this.employee = { id: null }
      this.createForm = true
    },
    setSelected (val) {
      this.employee = val
    },
    createRequest () {
      this.requestForm = true
      this.createForm = false
    },
    async confirmCreateForm (data) {
      if (!data.request) await this.updateEmployees(data)
      else {
        const result = await this.addEmployees(data)
        if (!isBoolean(result)) {
          this.error = result
        }
      }
      await this.fetchEmployees(0)
      this.createForm = false
    },
    async confirmRequestForm (info) {
      this.added = await this.addOnboardingRequest(info)
      window.setTimeout(() => { this.added = false }, 4000)
      this.createForm = false
      this.requestForm = false
    },
    closeForm () {
      this.requestForm = false
      this.createForm = false
    },
    editEmployee (data) {
      this.createForm = true
      this.employee = data
    }
  },
  computed: {
    ...mapGetters('salary', ['getEmployees']),
    ...mapGetters('user', ['accessToken'])
  },
  mounted () {
    const timer = window.setTimeout(() => {
      if (this.accessToken) {
        window.clearTimeout(timer)
        this.fetchEmployees(0)
      }
    }, 100)
  }
}
</script>

<style scoped>

</style>
